/**
 * Ô điều khiển dùng lại cho màn Cài đặt — giữ đúng khuôn `.setting-row`
 * và `.field` của `settings.html`.
 */

import { useId, type ReactNode } from 'react';

export function SettingSwitch({
  label,
  sub,
  checked,
  onChange,
  disabled,
}: {
  label: string;
  sub?: string;
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
}) {
  return (
    <div className="setting-row">
      <div className="grow">
        <b>{label}</b>
        {sub ? <div className="sub">{sub}</div> : null}
      </div>
      <label className="switch">
        <input
          type="checkbox"
          checked={checked}
          disabled={disabled}
          aria-label={label}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span className="track" />
      </label>
    </div>
  );
}

export function SettingNumber({
  label,
  sub,
  value,
  onChange,
  min,
  max,
  width = 110,
}: {
  label: string;
  sub?: string;
  value: number;
  onChange: (next: number) => void;
  min?: number;
  max?: number;
  width?: number;
}) {
  return (
    <div className="setting-row">
      <div className="grow">
        <b>{label}</b>
        {sub ? <div className="sub">{sub}</div> : null}
      </div>
      <input
        type="number"
        style={{ width }}
        value={value}
        min={min}
        max={max}
        aria-label={label}
        onChange={(event) => onChange(Number(event.target.value))}
      />
    </div>
  );
}

export function SettingSelect({
  label,
  sub,
  value,
  onChange,
  children,
  width = 150,
}: {
  label: string;
  sub?: string;
  value: string;
  onChange: (next: string) => void;
  children: ReactNode;
  width?: number;
}) {
  return (
    <div className="setting-row">
      <div className="grow">
        <b>{label}</b>
        {sub ? <div className="sub">{sub}</div> : null}
      </div>
      <select
        style={{ width }}
        value={value}
        aria-label={label}
        onChange={(event) => onChange(event.target.value)}
      >
        {children}
      </select>
    </div>
  );
}

/** Danh sách chuỗi — mỗi dòng một giá trị (dải CIDR, slug vai trò…). */
export function SettingList({
  label,
  hint,
  value,
  onChange,
}: {
  label: string;
  hint?: string;
  value: string[];
  onChange: (next: string[]) => void;
}) {
  const id = useId();
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <textarea
        id={id}
        value={value.join('\n')}
        onChange={(event) =>
          onChange(
            event.target.value
              .split('\n')
              .map((line) => line.trim())
              .filter((line) => line.length > 0),
          )
        }
      />
      {hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
}

export function SettingText({
  label,
  hint,
  value,
  onChange,
  type = 'text',
  mono,
  placeholder,
}: {
  label: string;
  hint?: string;
  value: string;
  onChange: (next: string) => void;
  type?: string;
  mono?: boolean;
  placeholder?: string;
}) {
  const id = useId();
  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type={type}
        className={mono ? 'mono' : undefined}
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
      />
      {hint ? <span className="hint">{hint}</span> : null}
    </div>
  );
}
